
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Close, Create, FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import ButtonDelete from 'hooks/ButtonDelete';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código de dia', accessor: 'code'},
  { Header: 'Días no operativos', accessor: 'description'},
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
};
export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  const { id, showNotify, fDReport, reload, fileReports } = props;
  const [model, setOpen] = useModal();

  return (
    <>
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          fileReports={fileReports}
          id={id}
        />
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard permission={ConstantPermissions[permission.store]}
            component={
              <CardIcon color="primary">
                <FileCopySharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado detallado de dias excluidos para el reporte
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="dias_excluidos_reporte"
            defaultWidth={700}
            columns={columns}
            data={
              fDReport?.map((item, i) => {
                let dayName = '';
                switch (item.code) {
                  case '00': dayName = 'LUNES';break;
                  case '01': dayName = 'MARTES';break;
                  case '02': dayName = 'MIÉRCOLES';break;
                  case '03': dayName = 'JUEVES';break;
                  case '04': dayName = 'VIERNES';break;
                  case '05': dayName = 'SÁBADO';break;
                  case '06': dayName = 'DOMINGO';break;
                  default: dayName = 'Día desconocido';
                }
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_UPDATE}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen(item)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <Button
                          justIcon
                          round
                          simple
                          onClick={() => {
                            props.confirm('report/file-day-report', item.id, reload);
                          }}
                          color={props.themeContext.buttonColorDanger}
                          className="remove"
                        >
                          <Close />
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  description: dayName,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
